export function decimalString(value) {
  const s = String(value ?? '').trim().replace(',', '.');
  if (!/^-?\d+(?:\.\d{1,6})?$/.test(s)) throw new Error('Importe inválido / Nieprawidłowa kwota');
  return s;
}
export function cents(value) {
  const s = decimalString(value || '0');
  if (!/^\d+(?:\.\d{1,2})?$/.test(s)) throw new Error('Solo céntimos / Tylko grosze');
  const [whole, fraction = ''] = s.split('.');
  return BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
}
export function centString(n) {
  const sign = n < 0n ? '-' : ''; const a = n < 0n ? -n : n;
  return `${sign}${a / 100n}.${String(a % 100n).padStart(2, '0')}`;
}
export function journalBalance(lines) {
  let debit = 0n, credit = 0n, valid = lines.length >= 2;
  try { for (const l of lines) { const d = cents(l.debit), c = cents(l.credit); debit += d; credit += c; if ((d > 0n) === (c > 0n)) valid = false; } }
  catch { valid = false; }
  return { debit:centString(debit), credit:centString(credit), difference:centString(debit-credit), balanced:valid && debit > 0n && debit === credit };
}
export function itemsOf(data) { return Array.isArray(data) ? data : data?.items || []; }
export function errorDetail(error) {
  const detail = error?.response?.data?.detail ?? error?.serverDetail;
  if (Array.isArray(detail)) return detail.map(e => `${(e.loc || []).join('.')}: ${e.msg}`).join('; ');
  return typeof detail === 'string' ? detail : error?.message || 'Error de conexión / Błąd połączenia';
}
export function assetSchedule(asset) {
  const cost = cents(asset.cost), residual = cents(asset.residual_value || '0'), months = Number(asset.useful_life_months);
  if (!Number.isInteger(months) || months < 1 || months > 1200 || cost <= 0n || residual > cost || !/^\d{4}-\d{2}-\d{2}$/.test(asset.start_date || '')) throw new Error('Revise coste, vida útil y fecha / Sprawdź koszt, okres i datę');
  const [y,m,d] = asset.start_date.split('-').map(Number);
  const date = new Date(`${asset.start_date}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime()) || date.getUTCFullYear() !== y || date.getUTCMonth()+1 !== m || date.getUTCDate() !== d || y + Math.floor((m-1+months-1)/12) > 9999) throw new Error('Fecha inválida / Nieprawidłowa data');
  const base = cost - residual, monthly = (base + BigInt(Math.floor(months / 2))) / BigInt(months);
  let accumulated = 0n;
  return Array.from({length:months}, (_,i) => {
    const rest = base - accumulated, amount = i === months - 1 ? rest : monthly > rest ? rest : monthly;
    accumulated += amount; const month = m - 1 + i;
    return {period:`${y + Math.floor(month/12)}-${String(month%12+1).padStart(2,'0')}`,amount:centString(amount),accumulated:centString(accumulated),book_value:centString(cost-accumulated)};
  });
}
export function money(value, locale = 'es') {
  if (value === undefined || value === null || value === '') return '—';
  const n = Number(value); return Number.isFinite(n) ? new Intl.NumberFormat(locale === 'pl' ? 'pl-PL' : 'es-ES', {style:'currency',currency:'EUR'}).format(n) : String(value);
}
export function todayISO() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; }

